
const colors = [
    '#2216a0',
    '#3F903C',
    '#984ea3',
    '#39CEE8',
    '#a65628',
    '#f781bf',
    '#3CC735',
    '#4a86db'
];

const circleMarkerStyle = {
    radius: 5,
    color: '#000',
    weight: 0,
    opacity: 1,
    fillOpacity: 0.9
};

export default class ColorHandler {
    private colorCursor = 0;
    private featureTypeColors: { [keyy: number]: string } = {};
    constructor(private readonly cycleThroughColors: boolean) {

    }

    getNewColor(){
        const index = this.cycleThroughColors ? this.colorCursor++ % colors.length : 0;
        return  colors[index];
    }

    colorForFeatureType(featureTypeId: number) {
        if (!this.featureTypeColors[featureTypeId]){
            this.featureTypeColors[featureTypeId] = this.getNewColor();
        }
        return this.featureTypeColors[featureTypeId];
    }

    circleMarkerForFeatureType(featureTypeId: number) {
        const color = {fillColor: this.colorForFeatureType(featureTypeId)};
        return {...color, ...circleMarkerStyle};
    }
}
